import React, { useState, memo } from 'react';
import { useParams } from 'react-router-dom';
import { Wifi, Car, UtensilsCrossed, Wind, Tv, Coffee, Star, CheckCircle, Award } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { BookingModal } from '../components/BookingModal';
export function PropertyDetail() {
  const {
    id
  } = useParams();
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  // Property data with real images
  const properties: Record<string, any> = {
    'the-ark': {
      title: 'The Ark',
      subtitle: 'Spacious 4-BHK Villa @ Kochi',
      location: 'Maradu, Kochi, Kerala',
      description: 'Experience the grandeur of this stunning 4-bedroom villa in Maradu. "The Ark" features beautiful gardens, spacious living areas across two floors, and premium amenities. Perfect for families and large groups looking for an authentic Kochi experience with modern luxury.',
      price: 12499,
      rating: 4.96,
      reviews: 25,
      bedrooms: 4,
      bathrooms: 5,
      sleeps: 14,
      beds: 5,
      airbnbUrl: 'https://airbnb.co.in/h/fortkochin',
      amenities: [{
        icon: Wifi,
        name: 'High-speed Wifi'
      }, {
        icon: Wind,
        name: 'Air Conditioning'
      }, {
        icon: UtensilsCrossed,
        name: 'Full Kitchen'
      }, {
        icon: Car,
        name: 'Free Parking'
      }, {
        icon: Tv,
        name: 'Smart TV'
      }, {
        icon: Coffee,
        name: 'Coffee Maker'
      }],
      images: ['https://a0.muscache.com/im/pictures/hosting/Hosting-1318026329502115922/original/520ca652-f1a5-4e24-a765-74ae5cc897f8.png?im_w=1440', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1318026329502115922/original/520ca652-f1a5-4e24-a765-74ae5cc897f8.png?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1318026329502115922/original/520ca652-f1a5-4e24-a765-74ae5cc897f8.png?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1318026329502115922/original/520ca652-f1a5-4e24-a765-74ae5cc897f8.png?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1318026329502115922/original/520ca652-f1a5-4e24-a765-74ae5cc897f8.png?im_w=720']
    },
    'the-haven': {
      title: 'The Haven',
      subtitle: 'Stylish 3BHK @ Kochi',
      location: 'Maradu, Kochi, Kerala',
      description: 'A beautifully designed 3-bedroom apartment in Maradu with stunning arched windows and elegant interiors. The Haven offers a perfect blend of heritage charm and modern comfort, ideal for families seeking a memorable Kochi stay.',
      price: 8499,
      rating: 5.0,
      reviews: 9,
      bedrooms: 3,
      bathrooms: 5,
      sleeps: 11,
      beds: 5,
      airbnbUrl: 'https://www.airbnb.co.in/h/keralam',
      amenities: [{
        icon: Wifi,
        name: 'High-speed Wifi'
      }, {
        icon: Wind,
        name: 'Air Conditioning'
      }, {
        icon: UtensilsCrossed,
        name: 'Full Kitchen'
      }, {
        icon: Car,
        name: 'Free Parking'
      }, {
        icon: Tv,
        name: 'Smart TV'
      }, {
        icon: Coffee,
        name: 'Coffee Maker'
      }],
      images: ['https://a0.muscache.com/im/pictures/hosting/Hosting-1392648310736278217/original/50bf55c8-d9cc-4562-bc5f-0efaf4402535.jpeg?im_w=1440', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1392648310736278217/original/50bf55c8-d9cc-4562-bc5f-0efaf4402535.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1392648310736278217/original/50bf55c8-d9cc-4562-bc5f-0efaf4402535.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1392648310736278217/original/50bf55c8-d9cc-4562-bc5f-0efaf4402535.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1392648310736278217/original/50bf55c8-d9cc-4562-bc5f-0efaf4402535.jpeg?im_w=720']
    },
    'ark-green': {
      title: 'Ark Green',
      subtitle: 'Stylish 2BHK Stay @ Kochi',
      location: 'Maradu, Kochi, Kerala',
      description: 'A modern and stylish 2-bedroom suite in Maradu with contemporary furnishings and a cozy atmosphere. Ark Green is perfect for couples or small families looking for comfort and convenience in the heart of Kochi.',
      price: 7499,
      rating: 5.0,
      reviews: 9,
      bedrooms: 2,
      bathrooms: 2,
      sleeps: 5,
      beds: 2,
      airbnbUrl: 'https://www.airbnb.co.in/rooms/1312900432950527324',
      amenities: [{
        icon: Wifi,
        name: 'High-speed Wifi'
      }, {
        icon: Wind,
        name: 'Air Conditioning'
      }, {
        icon: UtensilsCrossed,
        name: 'Full Kitchen'
      }, {
        icon: Car,
        name: 'Free Parking'
      }, {
        icon: Tv,
        name: 'Smart TV'
      }, {
        icon: Coffee,
        name: 'Coffee Maker'
      }],
      images: ['https://a0.muscache.com/im/pictures/hosting/Hosting-1300574331154492461/original/f39bc531-627c-420a-b66d-74c2bb383fd3.jpeg?im_w=1440', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1300574331154492461/original/f39bc531-627c-420a-b66d-74c2bb383fd3.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1300574331154492461/original/f39bc531-627c-420a-b66d-74c2bb383fd3.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1300574331154492461/original/f39bc531-627c-420a-b66d-74c2bb383fd3.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1300574331154492461/original/f39bc531-627c-420a-b66d-74c2bb383fd3.jpeg?im_w=720']
    },
    'ark-gold': {
      title: 'Ark Gold',
      subtitle: 'Stylish 2BHK Stay @ Kochi',
      location: 'Maradu, Kochi, Kerala',
      description: 'Sister property to Ark Green in Maradu, Ark Gold offers the same level of comfort and style with unique decor and an extra bathroom. Perfect for couples or small families seeking a peaceful retreat in Kochi.',
      price: 6499,
      rating: 5.0,
      reviews: 9,
      bedrooms: 2,
      bathrooms: 3,
      sleeps: 6,
      beds: 3,
      airbnbUrl: 'https://www.airbnb.co.in/rooms/1300574331154492461',
      amenities: [{
        icon: Wifi,
        name: 'High-speed Wifi'
      }, {
        icon: Wind,
        name: 'Air Conditioning'
      }, {
        icon: UtensilsCrossed,
        name: 'Full Kitchen'
      }, {
        icon: Car,
        name: 'Free Parking'
      }, {
        icon: Tv,
        name: 'Smart TV'
      }, {
        icon: Coffee,
        name: 'Coffee Maker'
      }],
      images: ['https://a0.muscache.com/im/pictures/hosting/Hosting-1312900432950527324/original/7241b004-b870-4614-987e-63f0ae367f2d.jpeg?im_w=1440', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1312900432950527324/original/7241b004-b870-4614-987e-63f0ae367f2d.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1312900432950527324/original/7241b004-b870-4614-987e-63f0ae367f2d.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1312900432950527324/original/7241b004-b870-4614-987e-63f0ae367f2d.jpeg?im_w=720', 'https://a0.muscache.com/im/pictures/hosting/Hosting-1312900432950527324/original/7241b004-b870-4614-987e-63f0ae367f2d.jpeg?im_w=720']
    }
  };
  const property = properties[id || 'the-ark'] || properties['the-ark'];
  return <div className="bg-white min-h-screen pb-20" data-id="element-444">
      {/* Gallery Section */}
      <div className="h-[60vh] md:h-[80vh] grid grid-cols-1 md:grid-cols-4 grid-rows-2 gap-2 p-2" data-id="element-445">
        <div className="md:col-span-2 md:row-span-2 relative group overflow-hidden rounded-lg" data-id="element-446">
          <img src={property.images[0]} alt={`${property.title} - Main View`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-447" />
        </div>
        <div className="hidden md:block relative group overflow-hidden rounded-lg" data-id="element-448">
          <img src={property.images[1]} alt={`${property.title} - Interior 1`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-449" />
        </div>
        <div className="hidden md:block relative group overflow-hidden rounded-lg" data-id="element-450">
          <img src={property.images[2]} alt={`${property.title} - Interior 2`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-451" />
        </div>
        <div className="hidden md:block relative group overflow-hidden rounded-lg" data-id="element-452">
          <img src={property.images[3]} alt={`${property.title} - Interior 3`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-453" />
        </div>
        <div className="hidden md:block relative group overflow-hidden rounded-lg" data-id="element-454">
          <img src={property.images[4]} alt={`${property.title} - Interior 4`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-455" />
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer" data-id="element-456">
            <span className="text-white font-medium border border-white px-4 py-2 rounded-full" data-id="element-457">
              View All Photos
            </span>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8" data-id="element-458">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-459">
          {/* Left Column: Details */}
          <div className="lg:col-span-2" data-id="element-460">
            <div className="mb-8 border-b border-[#FAF7F2] pb-8" data-id="element-461">
              {/* Superhost Badge */}
              <div className="inline-flex items-center gap-2 bg-[#FAF7F2] px-3 py-1.5 rounded-full mb-4" data-id="element-462">
                <Award className="h-4 w-4 text-[#FF385C]" data-id="element-463" />
                <span className="text-xs font-bold text-[#2C2C2C]" data-id="element-464">
                  Airbnb Superhost
                </span>
              </div>

              <div className="flex justify-between items-start mb-4" data-id="element-465">
                <div data-id="element-466">
                  <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-2" data-id="element-467">
                    {property.title}
                  </h1>
                  <p className="text-[#5C5C5C] text-lg mb-2" data-id="element-468">
                    {property.subtitle}
                  </p>
                  <p className="text-[#5C5C5C] flex items-center gap-2" data-id="element-469">
                    <span className="font-medium" data-id="element-470">{property.location}</span>
                    <span data-id="element-471">•</span>
                    <span className="flex items-center text-[#D4AF37]" data-id="element-472">
                      <Star className="h-4 w-4 fill-current mr-1" data-id="element-473" />{' '}
                      {property.rating} ({property.reviews} reviews)
                    </span>
                  </p>
                </div>
              </div>

              <div className="flex gap-4 overflow-x-auto pb-2 mb-6" data-id="element-474">
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-[#FAF7F2] text-[#8B7355] text-sm font-medium whitespace-nowrap" data-id="element-475">
                  {property.bedrooms} Bedrooms
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-[#FAF7F2] text-[#8B7355] text-sm font-medium whitespace-nowrap" data-id="element-476">
                  {property.beds} Beds
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-[#FAF7F2] text-[#8B7355] text-sm font-medium whitespace-nowrap" data-id="element-477">
                  {property.bathrooms} Bathrooms
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-[#FAF7F2] text-[#8B7355] text-sm font-medium whitespace-nowrap" data-id="element-478">
                  Sleeps {property.sleeps}
                </span>
              </div>

              <p className="text-[#5C5C5C] leading-relaxed text-lg" data-id="element-479">
                {property.description}
              </p>
            </div>

            <div className="mb-12" data-id="element-480">
              <h2 className="font-serif text-2xl font-bold text-[#2C2C2C] mb-6" data-id="element-481">
                Amenities
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-6" data-id="element-482">
                {property.amenities.map((item: any, idx: number) => <div key={idx} className="flex items-center gap-3 p-3 rounded-lg hover:bg-[#FAF7F2] transition-colors" data-id="element-483">
                    <item.icon className="h-6 w-6 text-[#8B7355]" data-id="element-484" />
                    <span className="text-[#5C5C5C]" data-id="element-485">{item.name}</span>
                  </div>)}
              </div>
            </div>
          </div>

          {/* Right Column: Sticky Booking Card */}
          <div className="lg:col-span-1" data-id="element-486">
            <div className="sticky top-24" data-id="element-487">
              <Card className="p-6 border-[#D4AF37]/20 shadow-xl" data-id="element-488">
                <div className="flex justify-between items-end mb-6" data-id="element-489">
                  <div data-id="element-490">
                    <span className="text-3xl font-bold text-[#2C2C2C]" data-id="element-491">
                      ₹{property.price.toLocaleString()}
                    </span>
                    <span className="text-[#5C5C5C]" data-id="element-492"> / night</span>
                  </div>
                  <div className="flex items-center text-sm text-[#5C5C5C]" data-id="element-493">
                    <Star className="h-4 w-4 text-[#D4AF37] fill-[#D4AF37] mr-1" data-id="element-494" />
                    <span className="font-bold text-[#2C2C2C] mr-1" data-id="element-495">
                      {property.rating}
                    </span>
                    <span className="underline decoration-dotted" data-id="element-496">
                      {property.reviews} reviews
                    </span>
                  </div>
                </div>

                <a href={property.airbnbUrl} target="_blank" rel="noopener noreferrer" className="block mb-4" data-id="element-497">
                  <Button className="w-full bg-[#FF385C] hover:bg-[#E31C5F] text-white border-none" size="lg" data-id="element-498">
                    <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-499">
                      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10z" data-id="element-500" />
                      <path d="M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" data-id="element-501" />
                    </svg>
                    Book on Airbnb
                  </Button>
                </a>

                <p className="text-center text-xs text-[#5C5C5C] mb-6" data-id="element-502">
                  Instant booking available on Airbnb
                </p>

                <div className="space-y-3 pt-6 border-t border-gray-100" data-id="element-503">
                  <div className="flex justify-between text-sm text-[#5C5C5C]" data-id="element-504">
                    <span data-id="element-505">Starting from</span>
                    <span className="font-bold text-[#2C2C2C]" data-id="element-506">
                      ₹{property.price.toLocaleString()} / night
                    </span>
                  </div>
                </div>
              </Card>

              <div className="mt-6 bg-[#FAF7F2] p-4 rounded-lg flex items-start gap-3" data-id="element-507">
                <CheckCircle className="h-5 w-5 text-[#8B7355] shrink-0 mt-0.5" data-id="element-508" />
                <div data-id="element-509">
                  <p className="font-bold text-sm text-[#2C2C2C]" data-id="element-510">
                    Flexible cancellation
                  </p>
                  <p className="text-xs text-[#5C5C5C]" data-id="element-511">
                    Check Airbnb for cancellation policy details.
                  </p>
                </div>
              </div>

              <a href={`https://wa.me/919746603446?text=Hi, I'm interested in ${property.title}`} target="_blank" rel="noopener noreferrer" className="mt-4 block" data-id="element-512">
                <Button variant="outline" className="w-full border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white" data-id="element-513">
                  Chat on WhatsApp
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} propertyName={property.title} data-id="element-514" />
    </div>;
}